import { Injectable, signal } from '@angular/core';
import { IVoucherType } from '../interfaces/IVoucherType';

@Injectable({
  providedIn: 'root'
})
export class VouchersStore {

  public readonly voucherTypes = signal<IVoucherType[]>([]);
  public readonly externalVoucherTypes = signal<IVoucherType[]>([]);

  public generateDistributorVoucherNumber(): string {
    const storageKey = 'cinetixx.cash.distributor-voucher-number';
    const currentValue = Number(sessionStorage.getItem(storageKey) ?? '0');
    const nextValue = Number.isFinite(currentValue) && currentValue > 0 ? currentValue + 1 : 1;

    sessionStorage.setItem(storageKey, String(nextValue));

    return String(nextValue);
  }
}
